import React, { useState } from 'react';

const FAQ = () => {
  const [activeIndex, setActiveIndex] = useState(null);

  const toggleFAQ = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const styles = {
    container: {
      backgroundColor: '#ffffff',
      color: '#333333',
      minHeight: '100vh',
      padding: '4rem 2rem',
      fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
      lineHeight: '1.6'
    },
    content: {
      maxWidth: '900px',
      margin: '0 auto',
    },
    header: {
      textAlign: 'center',
      marginBottom: '3rem',
      borderBottom: '2px solid #000000',
      paddingBottom: '1.5rem'
    },
    title: {
      fontSize: '2.5rem',
      fontWeight: '700',
      color: '#000000',
      marginBottom: '0.5rem'
    },
    subtitle: {
      fontSize: '1.2rem',
      color: '#555555',
      fontWeight: '300'
    },
    section: {
      marginBottom: '3rem'
    },
    sectionTitle: {
      fontSize: '1.8rem',
      fontWeight: '600',
      color: '#000000',
      borderBottom: '1px solid #eeeeee',
      paddingBottom: '0.5rem',
      marginBottom: '1.5rem'
    },
    faqItem: {
      borderBottom: '1px solid #eeeeee',
      padding: '1.5rem 0',
      cursor: 'pointer',
      transition: 'all 0.3s ease'
    },
    faqQuestion: {
      fontSize: '1.2rem',
      fontWeight: '600',
      color: '#000000',
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center'
    },
    faqAnswer: {
      fontSize: '1.1rem',
      color: '#555555',
      paddingTop: '1rem',
      lineHeight: '1.7'
    },
    icon: {
      fontSize: '1.5rem',
      transition: 'transform 0.3s ease'
    },
    techTag: {
      backgroundColor: '#f5f5f5',
      padding: '0.3rem 0.8rem',
      borderRadius: '20px',
      fontSize: '0.8rem',
      color: '#333333',
      margin: '0.3rem',
      display: 'inline-block'
    }
  };

  const faqs = [
    // قسم المهارات التقنية
    {
      question: "ما هي لغات البرمجة التي تتقنها؟",
      answer: <div>
        أتقن عدة لغات برمجة حسب المجال:
        <div style={{marginTop: '0.5rem'}}>
          <span style={styles.techTag}>JavaScript (ES6+)</span>
          <span style={styles.techTag}>Dart</span>
          <span style={styles.techTag}>Python</span>
          <span style={styles.techTag}>HTML5</span>
          <span style={styles.techTag}>CSS3</span>
        </div>
        <p style={{marginTop: '1rem'}}>مع التركيز على JavaScript لتطوير الويب و Dart لتطبيقات الموبايل.</p>
      </div>
    },
    {
      question: "ما هي أطر العمل والمكتبات التي تستخدمها؟",
      answer: <div>
        أستخدم مجموعة متنوعة من الأطر والمكتبات حسب احتياجات المشروع:
        <div style={{margin: '0.5rem 0'}}>
          <strong>واجهة المستخدم:</strong>
          <div>
            <span style={styles.techTag}>React.js</span>
            <span style={styles.techTag}>Next.js</span>
            <span style={styles.techTag}>Flutter</span>
            <span style={styles.techTag}>Tailwind CSS</span>
          </div>
        </div>
        <div style={{margin: '0.5rem 0'}}>
          <strong>الواجهة الخلفية:</strong>
          <div>
            <span style={styles.techTag}>Node.js</span>
            <span style={styles.techTag}>Express</span>
            <span style={styles.techTag}>Firebase</span>
          </div>
        </div>
        <div style={{margin: '0.5rem 0'}}>
          <strong>قواعد البيانات:</strong>
          <div>
            <span style={styles.techTag}>MongoDB</span>
            <span style={styles.techTag}>MySQL</span>
            <span style={styles.techTag}>Firestore</span>
          </div>
        </div>
      </div>
    },
    {
      question: "ما هي أدوات التطوير التي تفضل استخدامها؟",
      answer: <div>
        أستخدم مجموعة من الأدوات لتحسين جودة وكفاءة العمل:
        <ul style={{marginTop: '0.5rem', paddingLeft: '1.5rem'}}>
          <li>VS Code كمحرر أساسي</li>
          <li>Git & GitHub لإدارة الإصدارات</li>
          <li>Postman لاختبار APIs</li>
          <li>Figma لتصميم الواجهات</li>
          <li>Docker لتطوير الحاويات</li>
        </ul>
      </div>
    },

    // قسم المشاريع والخبرات
    {
      question: "ما هي أبرز المشاريع التي قمت بتنفيذها؟",
      answer: <div>
        من أبرز مشاريعي:
        <ul style={{marginTop: '0.5rem', paddingLeft: '1.5rem'}}>
          <li><strong>نظام الحضور الذكي:</strong> نظام متكامل لإدارة حضور الموظفين باستخدام تقنيات MERN Stack</li>
          <li><strong>منصة مساعدة المرضى:</strong> تطبيق متكامل لإدارة الرحلات العلاجية باستخدام Flutter و node.js express</li>
          <li><strong>متجر إلكتروني:</strong>منصة و تطبيق بيع الفضة</li>
<li><strong>تطبيق استراحة:</strong> تطبيق يوفر مكتبة متنوعة من المسلسلات، الأفلام، والفيديوهات للمشاهدة عبر الإنترنت</li>
        </ul>
      </div>
    },
    {
      question: "ما هي خبرتك في العمل الحر؟",
      answer: <div>
        لدي خبرة تزيد عن 1 سنوات في العمل الحر حيث قمت بـ:
        <ul style={{marginTop: '0.5rem', paddingLeft: '1.5rem'}}>
          <li>تطوير أكثر من 10 موقع وتطبيق لعملاء</li>
          <li>التعاون مع فرق تطوير عن بعد</li>
          <li>إدارة مشاريع كاملة من التصميم حتى النشر</li>
          <li>تقديم حلول تقنية مبتكرة لمشاكل العملاء</li>
        </ul>
        مع تقييمات إيجابية.
      </div>
    },
    {
      question: "هل لديك خبرة في العمل مع فرق تطوير؟",
      answer: <div>
        نعم، لدي خبرة في العمل ضمن فرق تطوير حيث:
        <ul style={{marginTop: '0.5rem', paddingLeft: '1.5rem'}}>
          <li>عملت كمطور Front-end في فريق يتكون من 4 أفراد</li>
          <li>استخدمت منهجيات Agile  في إدارة المشاريع</li>
          <li>تعاونت مع مصممين ومديري منتجات ومطورين آخرين</li>
        </ul>
      </div>
    },

    // قسم منهجية العمل
    {
      question: "ما هي منهجيتك في تطوير البرمجيات؟",
      answer: <div>
        أتبع منهجية علمية في التطوير تشمل:
        <ul style={{marginTop: '0.5rem', paddingLeft: '1.5rem'}}>
          <li>تحليل متطلبات المشروع بدقة</li>
          <li>تصميم معماري متين وقابل للتوسع</li>
          <li>كتابة كود نظيف ومعلق جيداً</li>
          <li>تنفيذ اختبارات وحدة واختبارات تكامل</li>
          <li>مراجعة الأقران (Peer Review) للكود</li>
          <li>نشر وتتبع الأخطاء بعد الإطلاق</li>
        </ul>
        مع التركيز على مبادئ SOLID و DRY في البرمجة.
      </div>
    },
    {
      question: "كيف تتعامل مع المشاكل التقنية الصعبة؟",
      answer: <div>
        أتبع منهجية منظمة لحل المشكلات:
        <ol style={{marginTop: '0.5rem', paddingLeft: '1.5rem'}}>
          <li>فهم المشكلة بدقة وتحديد أعراضها</li>
          <li>البحث عن حلول موجودة أو مشابهة</li>
          <li>تقسيم المشكلة إلى أجزاء أصغر</li>
          <li>تنفيذ الحلول بشكل تدريجي</li>
          <li>اختبار الحلول والتأكد من فعاليتها</li>
          <li>توثيق الحل للمستقبل</li>
        </ol>
        مع الاستعانة بمجتمعات المطورين مثل Stack Overflow عند الحاجة.
      </div>
    },
    {
      question: "ما هي معايير الجودة التي تتبعها في مشاريعك؟",
      answer: <div>
        التزامي بجودة المشاريع يشمل:
        <ul style={{marginTop: '0.5rem', paddingLeft: '1.5rem'}}>
          <li>تحقيق أعلى معايير أداء التطبيق</li>
          <li>ضمان تجربة مستخدم ممتازة</li>
          <li>تطبيق أفضل ممارسات الأمان</li>
          <li>كتابة كود قابل للقراءة والصيانة</li>
          <li>تحسين أداء التطبيق للسرعة والكفاءة</li>
          <li>التوافق مع مختلف المتصفحات والأجهزة</li>
          <li>توثيق شامل للكود والمشروع</li>
        </ul>
      </div>
    },

    // قسم التطوير المهني
    {
      question: "كيف تحافظ على تحديث مهاراتك التقنية؟",
      answer: <div>
        أحرص على التطوير المستمر لمهاراتي من خلال:
        <ul style={{marginTop: '0.5rem', paddingLeft: '1.5rem'}}>
          <li>متابعة أحدث التقنيات عبر المدونات والمجلات التقنية</li>
          <li>الاشتراك في دورات تدريبية متقدمة</li>
          <li>المشاركة في مجتمعات المطورين</li>
          <li>تنفيذ مشاريع جانبية لتجربة تقنيات جديدة</li>
          <li>الحصول على شهادات متخصصة</li>
        </ul>
      </div>
    },
    {
      question: "ما هي مجالات التخصص التي تركز عليها؟",
      answer: <div>
        أركز حالياً على:
        <ul style={{marginTop: '0.5rem', paddingLeft: '1.5rem'}}>
          <li>تطوير تطبيقات الويب المتقدمة (PWA)</li>
          <li>تحسين أداء التطبيقات (Performance Optimization)</li>
          <li>تطبيقات الهاتف متعددة المنصات</li>
          <li>التكامل مع خدمات السحابة (Cloud Services)</li>
          <li>واجهات برمجة التطبيقات الآمنة (Secure APIs)</li>
        </ul>
        مع اهتمام متزايد بمجالات الذكاء الاصطناعي وتعلم الآلة.
      </div>
    },
    {
      question: "ما هي خططك المستقبلية للتطوير المهني؟",
      answer: <div>
        أسعى لتحقيق الأهداف التالية:
        <ul style={{marginTop: '0.5rem', paddingLeft: '1.5rem'}}>
          <li>التعمق في هندسة البرمجيات المتقدمة</li>
          <li>إتقان تطوير تطبيقات الويب التقدمية (PWA)</li>
          <li>التوسع في مجال الحوسبة السحابية</li>
          <li>الحصول على شهادات متقدمة في تخصصات محددة</li>
          <li>تطوير منتجات تقنية مبتكرة</li>
          <li>المشاركة في مشاريع مفتوحة المصدر</li>
        </ul>
      </div>
    },

    // قسم العمل مع العملاء
    {
      question: "ما هي خطواتك عند بدء مشروع جديد مع عميل؟",
      answer: <div>
        أتبع هذه الخطوات لضمان نجاح المشروع:
        <ol style={{marginTop: '0.5rem', paddingLeft: '1.5rem'}}>
          <li>اجتماع تفصيلي لفهم المتطلبات</li>
          <li>تحليل الجدوى التقنية</li>
          <li>تقديم مقترح تقني ومالي</li>
          <li>توقيع عقد واضح يحدد النطاق والجدول الزمني</li>
          <li>تخطيط معماري وتصميم أولي</li>
          <li>تطوير واختبار وتنفيذ</li>
          <li>التسليم والتدريب</li>
          <li>الدعم والصيانة</li>
        </ol>
      </div>
    },
    {
      question: "كيف تتعامل مع التغييرات في متطلبات المشروع؟",
      answer: <div>
        أتبع سياسة واضحة لإدارة التغييرات:
        <ul style={{marginTop: '0.5rem', paddingLeft: '1.5rem'}}>
          <li>توثيق جميع المتطلبات الأولية بدقة</li>
          <li>تقييم تأثير أي تغيير على الجدول الزمني والتكلفة</li>
          <li>مناقشة التغييرات مع العميل بشكل شفاف</li>
          <li>تعديل العقد عند الحاجة لتغطية التغييرات الكبيرة</li>
          <li>إعطاء الأولوية للتغييرات الأكثر أهمية</li>
          <li>توثيق جميع التغييرات وإبلاغ جميع الأطراف</li>
        </ul>
      </div>
    },
    {
      question: "ما هي سياساتك فيما يخص الدعم والصيانة؟",
      answer: <div>
        أقدم خيارات متعددة للدعم والصيانة:
        <ul style={{marginTop: '0.5rem', paddingLeft: '1.5rem'}}>
          <li><strong>الدعم الفوري:</strong> حل المشاكل الحرجة خلال 24 ساعة</li>
          <li><strong>الصيانة الدورية:</strong> تحديثات وتحسينات منتظمة</li>
          <li><strong>التدريب:</strong> جلسات تدريبية للعميل على النظام</li>
          <li><strong>التوثيق:</strong> دليل استخدام شامل للأنظمة</li>
        </ul>
        مع تحديد واضح لفترات الضمان والمسؤوليات.
      </div>
    }
  ];

  return (
    <div style={styles.container}>
      <div style={styles.content}>
        <header style={styles.header}>
          <h1 style={styles.title}>الأسئلة الشائعة</h1>
          <p style={styles.subtitle}>إجابات مفصلة على جميع استفساراتك حول عملي وخدماتي</p>
        </header>

        <section style={styles.section}>
          <h2 style={styles.sectionTitle}>المهارات والخبرات التقنية</h2>
          {faqs.slice(0, 3).map((faq, index) => (
            <div 
              key={index} 
              style={styles.faqItem}
              onClick={() => toggleFAQ(index)}
            >
              <div style={styles.faqQuestion}>
                {faq.question}
                <span style={{...styles.icon, transform: activeIndex === index ? 'rotate(180deg)' : 'rotate(0deg)'}}>
                  {activeIndex === index ? '−' : '+'}
                </span>
              </div>
              {activeIndex === index && (
                <div style={styles.faqAnswer}>{faq.answer}</div>
              )}
            </div>
          ))}
        </section>

        <section style={styles.section}>
          <h2 style={styles.sectionTitle}>المشاريع والخبرات العملية</h2>
          {faqs.slice(3, 6).map((faq, index) => (
            <div 
              key={index + 3} 
              style={styles.faqItem}
              onClick={() => toggleFAQ(index + 3)}
            >
              <div style={styles.faqQuestion}>
                {faq.question}
                <span style={{...styles.icon, transform: activeIndex === index + 3 ? 'rotate(180deg)' : 'rotate(0deg)'}}>
                  {activeIndex === index + 3 ? '−' : '+'}
                </span>
              </div>
              {activeIndex === index + 3 && (
                <div style={styles.faqAnswer}>{faq.answer}</div>
              )}
            </div>
          ))}
        </section>

        <section style={styles.section}>
          <h2 style={styles.sectionTitle}>منهجية العمل والتطوير</h2>
          {faqs.slice(6, 9).map((faq, index) => (
            <div 
              key={index + 6} 
              style={styles.faqItem}
              onClick={() => toggleFAQ(index + 6)}
            >
              <div style={styles.faqQuestion}>
                {faq.question}
                <span style={{...styles.icon, transform: activeIndex === index + 6 ? 'rotate(180deg)' : 'rotate(0deg)'}}>
                  {activeIndex === index + 6 ? '−' : '+'}
                </span>
              </div>
              {activeIndex === index + 6 && (
                <div style={styles.faqAnswer}>{faq.answer}</div>
              )}
            </div>
          ))}
        </section>

        <section style={styles.section}>
          <h2 style={styles.sectionTitle}>التطوير المهني والتعلم</h2>
          {faqs.slice(9, 12).map((faq, index) => (
            <div 
              key={index + 9} 
              style={styles.faqItem}
              onClick={() => toggleFAQ(index + 9)}
            >
              <div style={styles.faqQuestion}>
                {faq.question}
                <span style={{...styles.icon, transform: activeIndex === index + 9 ? 'rotate(180deg)' : 'rotate(0deg)'}}>
                  {activeIndex === index + 9 ? '−' : '+'}
                </span>
              </div>
              {activeIndex === index + 9 && (
                <div style={styles.faqAnswer}>{faq.answer}</div>
              )}
            </div>
          ))}
        </section>

        <section style={styles.section}>
          <h2 style={styles.sectionTitle}>العمل مع العملاء</h2>
          {faqs.slice(12).map((faq, index) => (
            <div 
              key={index + 12} 
              style={styles.faqItem}
              onClick={() => toggleFAQ(index + 12)}
            >
              <div style={styles.faqQuestion}>
                {faq.question}
                <span style={{...styles.icon, transform: activeIndex === index + 12 ? 'rotate(180deg)' : 'rotate(0deg)'}}>
                  {activeIndex === index + 12 ? '−' : '+'}
                </span>
              </div>
              {activeIndex === index + 12 && (
                <div style={styles.faqAnswer}>{faq.answer}</div>
              )}
            </div>
          ))}
        </section>
      </div>
    </div>
  );
};

export default FAQ;